import PhoneCountryCodes from './PhoneCountryCodes';

export type PhoneCountryCodeOptionsProps = {
  shortCode?: boolean;
};

export function PhoneCountryCodeOptions({ shortCode }: PhoneCountryCodeOptionsProps) {
  return (
    <>
      {PhoneCountryCodes.map(({ phone, iso, name }) => (
        <option key={`${phone} ${iso}`} value={`${phone} ${iso}`}>
          {shortCode ? iso : name}&nbsp;{phone}
        </option>
      ))}
    </>
  );
}
